import type { IRoute } from '@/shared/models/route.model';
import UserGuard from '../guards/UserGuard';
import EditorLayout from '../layout/EditorLayout';

import { lazy } from 'react';

const MainPage = lazy(() => import('../pages/main-page/MainPage'));
const CreateAdsStepsPage = lazy(() => import('../pages/create-ads-steps-page/CreateAdsStepsPage'));
const OrderDetailsPage = lazy(() => import('../pages/orders/details/OrderDetailsPage'));
const UserProfilePage = lazy(() => import('../pages/user-profile/UserProfilePage'));
const VideoLibrary = lazy(() => import('../pages/video-library/VideoLibrary'));

export const editorRoutes: IRoute[] = [
  {
    path: '/editor',
    component: EditorLayout,
    guard: UserGuard,
    children: [
      {
        path: '',
        component: MainPage,
      },
      {
        path: 'advertise/add',
        component: CreateAdsStepsPage,
      },
      {
        path: 'orders/:id/details',
        component: OrderDetailsPage,
      },
      {
        path: 'users/:userId/user-profile',
        component: UserProfilePage,
      },
      {
        path: 'videoLibrary',
        component: VideoLibrary,
      },
    ],
  },
];
